// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '../../index'

const state = () => ({})

const getters = {}

const mutations = {}

const actions = {
  toggleNotificationWidget ({ commit }) {
    commit('TOGGLE_ASIDE_NOTIFICATION_WIDGET')
    commit('CLOSE_ASIDE_DIALOG_WIDGET')
  },
  toggleDialogWidget ({ commit }) {
    commit('TOGGLE_ASIDE_DIALOG_WIDGET')
    commit('CLOSE_DIALOG_MESSAGE_LINK_TOOLTIP')
    commit('CLOSE_DIALOG_MESSAGE_TAG_TOOLTIP')
    commit('CLOSE_ASIDE_NOTIFICATION_WIDGET')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
